import styled from 'styled-components';

export const Container = styled('button')<{
  responsiveness: boolean | undefined;
  styles?: 1 | null;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-height: 45px;
  padding: clamp(10px, 3vh, 20px);

  background: #23ce6b;
  box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  color: #f6f8ff;
  font-weight: 700;
  white-space: nowrap;
  svg {
    width: auto;
    height: 30px;
    margin-right: 5%;
  }

  :disabled {
    background: rgba(0, 0, 0, 0.3);
    color: rgba(0, 0, 0, 0.4);
    cursor: not-allowed;
  }

  ${props =>
    props.responsiveness &&
    `@media (max-width: 570px) {
      position: fixed;
      justify-content: center;
      left: 0px;
      bottom: 50px;
      width: 90% !important;
      text-align: center;
      margin: 3% 5%;
      z-index: 997;} `}

  ${props =>
    props.styles === 1 &&
    `border: 2px solid #23ce6b;
     background: #fff;
     color: #23ce6b;`}
`;
